import { createContext } from 'react'
import { ModalProps } from '.'

type ModalContextType = ModalProps

const ModalContext = createContext<ModalContextType>(null)

export default ModalContext
